"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9504],{

/***/ 69504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8h5c.6 0 1 .4 1 1v5.4c0 4.3-3.1 7.6-7 7.6-3.4 0-6.2-2.5-6.9-6.1C4.6 15.5 2 12.3 2 8.4V3c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v5zM4 4v4.4C4 11.5 6.2 14 9 14s5-2.5 5-5.6V4H4zm11 16c2.8 0 5-2.5 5-5.6V10h-4.1c-.6 3.1-2.8 5.4-5.7 5.9.5 2.4 2.5 4.1 4.8 4.1zM11.7 9.3c.4.4.4 1 0 1.4-.1.1-1.3 1.3-2.7 1.3-1.4 0-2.6-1.2-2.7-1.3-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .3.3.9.7 1.3.7s1-.4 1.3-.7c.4-.4 1-.4 1.4 0zM7 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm5 7a1 1 0 100-2 1 1 0 000 2zm-4.7 3.3c.1-.1 1.3-1.3 2.7-1.3 1.4 0 2.6 1.2 2.7 1.3.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.3-.3-.9-.7-1.3-.7s-1 .4-1.3.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
}), "Theatre"));


/***/ })

}]);